var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 495.7 490.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eceff1;}.cls-2{fill:#2a5699;}.cls-3{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M480,418.09H259.87a15.72,15.72,0,0,1-15.72-15.72V87.93a15.73,15.73,0,0,1,15.72-15.72H480A15.74,15.74,0,0,1,495.7,87.93V402.37A15.73,15.73,0,0,1,480,418.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_381-word",
    "data-name": "381-word"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M440.08,228.81a16.35,16.35,0,0,0,0-32.69H293.38V163.44h146.7a16.35,16.35,0,0,0,0-32.69H293.38V16.35A16.23,16.23,0,0,0,287.49,3.8,16,16,0,0,0,274.09.3L13.3,49.33A16.33,16.33,0,0,0,0,65.38V424.93A16.32,16.32,0,0,0,13.3,441l260.79,49a15.18,15.18,0,0,0,3,.29A16.29,16.29,0,0,0,293.38,474V359.55h146.7a16.34,16.34,0,0,0,0-32.68H293.38V294.18h146.7a16.34,16.34,0,0,0,0-32.68H293.38V228.82h146.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228.09,181.58,211.79,328.7a16.33,16.33,0,0,1-14.18,14.38,13.7,13.7,0,0,1-2,.13,16.33,16.33,0,0,1-15.25-10.59l-33.65-90-33.64,90a16.29,16.29,0,0,1-31.39-3.46l-16.3-114.4a16.3,16.3,0,1,1,32.27-4.61l7.27,51.12,26.51-70.9c4.75-12.75,25.75-12.75,30.54,0l25,66.74L195.68,178a16.31,16.31,0,1,1,32.41,3.63Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.8cc3ddd8edbd579645a08323d3594acd.svg";
export { ForwardRef as ReactComponent };